import { useMemo, useState } from "react";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import {
  Button,
  Group,
  Indicator,
  Modal,
  Select,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { IconFilter, IconPlus } from "@tabler/icons-react";
import FilterContent from "../../../../../../components/Filter/FilterContent";
import { notifications } from "@mantine/notifications";
import PopOver from "../../../../../../components/View/PopOver";
import BackButton from "../../../../../../components/View/BackButton";
import { createCron } from "../../../../../../api/ConfigsApi";
import { useParams } from "react-router-dom";
import { useConfigStore } from "../../../../../../stores/ConfigStore";
import CreatableContactListSelector from "../../../../../../components/Selectors/CreatableContactListSelector";
import PRMStatusSelector from "../../../../../../components/Selectors/PRMStatusSelector";

const CreatePrmCron = ({ handleDone, defaultFilter, ...props }) => {
  const lang = useLanguage((s) => s.language);
  const { contactListId } = useParams();
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState({ id: parseInt(contactListId) });
  const [filter, setFilter] = useState(defaultFilter);

  const datafields = useConfigStore((s) => s.datafields);

  const fields = useMemo(() => {
    return [
      {
        label: lang.forms.fields,
        options: [
          { field: "id", id: "id", option_name: "ID" },
          ...datafields.map((x) => ({ ...x, option_name: x.name })),
        ],
      },
    ];
  }, [datafields]);

  const handleOpen = () => {
    setOpened(true);
    setFilter(defaultFilter || null);
  };
  const handleClose = () => {
    setOpened(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    let formData = new FormData(e.target);
    let data = Object.fromEntries(formData);

    const custom_status = parseInt(data.status);

    const args = {
      type: "contactlists_copy_contact_list_to_my_prm",
      from_contact_list_id: parseInt(contactListId),
      contacts_selection: {
        filter: filter || { mode: "or", values: [] },
        contact_ids: [],
        excluded_contact_ids: [],
      },
      custom_status: custom_status || undefined,
      status: custom_status ? "opener" : data.status,
    };

    createCron({
      name: data?.name,
      frequency: data?.frequency,
      args,
    })
      .then((response) => {
        notifications.show({
          message: lang.contact_lists.cron.created,
          color: "tertiary.8",
        });
        handleClose();
        handleDone();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        leftSection={<IconPlus size={18} />}
        size="md"
        {...props}
      >
        {lang.contact_lists.cron.new_cron}
      </Button>

      <Modal
        opened={opened}
        title={lang.contact_lists.cron.create_title_prm}
        onClose={handleClose}
        size={"50%"}
      >
        <Stack component={"form"} onSubmit={onSubmit}>
          <Group wrap="nowrap">
            <TextInput
              name="name"
              label={lang.contact_lists.cron.name}
              placeholder={"My cron"}
              required
              w={"100%"}
              autoFocus
              data-autofocus
              size="md"
            />

            <Select
              name="frequency"
              label={lang.sync_zapier.event_label}
              placeholder={lang.sync_zapier.event_label}
              defaultValue={"manual"}
              required
              data={Object.keys(lang.sync_zapier.frequency).map((x) => ({
                value: x,
                label: lang.sync_zapier.frequency[x],
              }))}
              size="md"
            />
          </Group>

          <CreatableContactListSelector
            value={list}
            setValue={setList}
            label={lang.contact_lists.cron.list_source}
            placeholder={lang.contact_lists.create.dialog.desc}
            w={"100%"}
            size="md"
            required
            disableCreate
            noDesc
          />

          <PRMStatusSelector
            label={"Status"}
            required
            withinPortal={true}
            name={"status"}
            id={"status"}
            size={"md"}
          />

          <Text mb={-8}>{lang.contact_lists.cron.filter_text}</Text>
          <PopOver
            opener={(openFunction, ref) => {
              return (
                <Button
                  ref={ref}
                  variant="default"
                  onClick={openFunction}
                  id={"cron-filter-" + "creation"}
                  size="md"
                >
                  <Indicator
                    color="red"
                    offset={2}
                    disabled={filter?.items?.length === 0 || !filter}
                    label={filter?.items?.length}
                    size={16}
                  >
                    <IconFilter size={18} />
                  </Indicator>
                  <span style={{ marginLeft: 6 }}>
                    {lang.table.toolbar.filter.main_button_label} *
                  </span>
                </Button>
              );
            }}
            popoverChildren={(closePopover) => (
              <FilterContent
                fields={fields}
                id={"cron-create"}
                isClient={false}
                pageName={"contact_lists_contacts"}
                maxHeight={350}
                mainFilter={filter}
                setMainFilter={(v) => {
                  closePopover();
                  setFilter(v);
                }}
                defaultFiltersClose
                getFieldOptionName={(f) => f.option_name}
              />
            )}
            elevation={3}
          />

          <Group justify="end" mt={"lg"}>
            <BackButton onClick={handleClose} size="md" />
            <Button
              // disabled={
              //   type === "prm" ? !filter || filter?.values?.length === 0 : false
              // }
              leftSection={<IconPlus size={18} />}
              loading={loading}
              type="submit"
              size="md"
            >
              {lang.contact_lists.cron.create}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default CreatePrmCron;
